import {Injectable} from "@angular/core";
import {ToastController} from "ionic-angular";

@Injectable()
export class AdminUtil {

    constructor(private toastCtrl: ToastController,
    ) {
    }

    showEmptyDataNotAllowedForFlds(fldNames) {
        // empty regime --> show toast
        let fldNamesStr = "";
        for (let aFldName of fldNames) {
            if (fldNamesStr.length == 0) {
                fldNamesStr = aFldName;
            } else {
                fldNamesStr = fldNamesStr + ", " + aFldName;
            }
        }

        this.toastCtrl.create({
            message: fldNamesStr + ' kann nicht leer sein!',
            duration: 2000,
            position: 'top'
        }).present();
    }
}



// WEBPACK FOOTER //
// ./src/pages/admin/adminUtil.ts